import apiClient from "./apiClient";

function periodParams(period) {
  if (!period) return {};
  return { params: { month: period.month, year: period.year } };
}

const companyAnalyticsApi = {
  getHraMetabolicRisk: async (companyId) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/hra/metabolic-risk`);
    return res.data; // { global, masculino, femenino }
  },
  getHraImc: async (companyId) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/hra/imc`);
    return res.data;
  },
  getHraTopDiseases: async (companyId) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/hra/top-diseases`);
    return res.data; // [{ name, count }]
  },
  getInbodyBmi: async (companyId, period) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/inbody/bmi`, periodParams(period));
    return res.data;
  },
  getInbodyPbf: async (companyId, period) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/inbody/pbf`, periodParams(period));
    return res.data;
  },
  getInbodyVfl: async (companyId, period) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/inbody/vfl`, periodParams(period));
    return res.data;
  },
  getSurveyCounts: async (companyId) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/surveys/counts`);
    return res.data;
  },
  getApplicationCounts: async (companyId) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/surveys/application-counts`);
    return res.data; // { [applicationId]: count }
  },
  getLabAnalytics: async (companyId, period) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/lab`, periodParams(period));
    return res.data;
  },
  getTygAnalytics: async (companyId, period) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/lab/tyg`, periodParams(period));
    return res.data;
  },
  getMetabolicRiskReal: async (companyId, crossFilter) => {
    const params = crossFilter ? {
      ibMonth:  crossFilter.ibPeriod.month,  ibYear:  crossFilter.ibPeriod.year,
      labMonth: crossFilter.labPeriod.month, labYear: crossFilter.labPeriod.year,
    } : {};
    const res = await apiClient.get(`/analytics/company/${companyId}/metabolic-risk/real`, { params });
    return res.data;
  },
  getAvailableCrosses: async (companyId) => {
    const res = await apiClient.get(`/analytics/company/${companyId}/metabolic-risk/real/crosses`);
    return res.data; // [{ ibPeriod: {month,year}, labPeriod: {month,year} }]
  },
};

export default companyAnalyticsApi;
